import { createContext } from 'react';
const HintsContext = createContext();
export default HintsContext;
